module.exports = __webpack_public_path__ + "static/homepage-mobile-dm-fdb9a9b070bedb13eb4a77d5355f3f17.jpg";